module.exports = __webpack_public_path__ + "static/step-4-6a5fa044cce4245c14b2f5f5640abec9.svg";